import React, {
    useEffect,
    useContext,
    useState,
    useCallback
} from 'react';
import { useModal } from '@jutro/components';
import { withRouter, Redirect, useHistory } from 'react-router-dom';
import _ from 'lodash';
import { Wizard } from 'gw-portals-wizard-react';
import { ViewModelServiceContext, withViewModelService } from 'gw-portals-viewmodel-react';
import { ErrorBoundary } from 'gw-portals-error-react';
import { Claim } from 'gw-capability-fnol-common-react';
import { messages as commonMessages } from 'gw-platform-translations';
import FNOLContext from './components/Context/Context';

import wizardConfig from './config/fnol-adac-wizard-config.json5';
import AdacCookiesModal from './components/AdacCookiesModal/AdacCookiesModal';
import ACTION_OPTIONS from './constants/FnolActionOptions';

function useActionOption() {
    const history = useHistory();
    const pathnameParts = history.location.pathname.split('/').filter((part) => part !== '');
    return pathnameParts[pathnameParts.length - 1];
}
function FNOLAdacWizard() {
    const { showAlert } = useModal();
    const history = useHistory();
    const { steps, title } = wizardConfig;
    const viewModelService = useContext(ViewModelServiceContext);
    const [initialClaim, setInitialClaim] = useState(null);
    const [actionOption, setActionOption] = useState();
    const [agreementConsent, setAgreementConsent] = useState(false);
    const actionOptionFromPath = useActionOption();
    const [updatedSteps, setUpdatedSteps] = useState(steps);
    const contextValue = {
        actionOption,
        agreementConsent,
        setActionOption,
        setAgreementConsent
    };

    useEffect(
        () => {
            const matchedOption = Object.values(ACTION_OPTIONS).find(
                (option) => option.toLowerCase() === actionOptionFromPath.toLowerCase()
            );

            if (!matchedOption) {
                history.push('/callcenter');
                return;
            }
            setActionOption(matchedOption);

            if (matchedOption !== ACTION_OPTIONS.option1) {
                setUpdatedSteps(steps.filter((step) => step.path !== '/incident-type'));
            }

            const claimValue = new Claim({policy: {policyNumber: undefined, policyType: 'travel_per'}});
            const claimVM = viewModelService.create(
                claimValue,
                'cc',
                'edge.capabilities.claim.fnol.dto.FnolDTO'
            );

            return setInitialClaim(claimVM);
        },
        // only execute once
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const handleError = useCallback((error) => {
        const state = {
            pathname: '/',
            state: error
        };

        return showAlert({
            title: commonMessages.genericError,
            message: commonMessages.genericErrorMessage,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).then(() => {
            return <Redirect to={state} />;
        }, _.noop);
    }, []);

    if (!initialClaim) {
        return null;
    }

    return (
        <ErrorBoundary onError={handleError}>
            <AdacCookiesModal/>
            <FNOLContext.Provider value={contextValue}>
                <Wizard
                    initialSteps={updatedSteps}
                    wizardTitle={title}
                    initialData={initialClaim}
                    skipCompletedSteps
                    onPrevious={_.noop}
                />
            </FNOLContext.Provider>
        </ErrorBoundary>
    );
}

export default withRouter(withViewModelService(FNOLAdacWizard));
